export const PAYMENTS_LIST_GET_PAYMENTS = "payments/list/PAYMENTS_LIST_GET_PAYMENTS";
export const PAYMENTS_LIST_GET_PAYMENTS_RESULT = "payments/list/PAYMENTS_LIST_GET_PAYMENTS_RESULT";